import React, { Component } from 'react'
import styled from 'styled-components'
import AdvertSignWrapper from './AdvertSignWrapper'
import SashecAdvert from './SashecAdvert'
import { sashecReloadPosition } from '../../utils/SashecHelpers'
import { SIZES } from '../../../constants'

const TopBanner = styled.div`
  display: block;
  height: auto;
  max-height: 210px;
  overflow: hidden;
  position: relative;
  text-align: center;

  @media screen and (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin: 15px auto;
    width: 100%;
  }

  @media screen and (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin-bottom: 10px;
  }
`

const BannerWrapper = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 1080px;
  position: relative;
  text-align: center;
  width: auto;

  @media screen and (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    max-width: 100%;
  }
`

const LEADER_POS = 1

export default class LeaderBoard extends Component {
  constructor (props) {
    super(props)

    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
  }

  shouldComponentUpdate () {
    return false
  }

  componentDidMount () {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  }

  componentWillUnmount () {
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
  }

  handleVisibilityChange () {
    const {
      widget: {
        meta: { targetId }
      }
    } = this.props

    if (document.visibilityState === 'visible') {
      sashecReloadPosition(targetId, LEADER_POS, 'rel')
    }
  }

  render () {
    const {
      widget: {
        meta: { targetId, size },
        group
      }
    } = this.props

    return (
      <TopBanner>
        <BannerWrapper>
          <div id={`${targetId}-wrapper`}>
            <AdvertSignWrapper />
            <SashecAdvert id={targetId} size={size} group={group} />
          </div>
        </BannerWrapper>
      </TopBanner>
    )
  }
}
